import React, { useState, useEffect } from "react";
import AppRouter from "./components/Router.component";
import firebase from "firebase/app";
import "firebase/auth";
import ReactGA from "react-ga";

ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID);

const handleSignIn = (setIsAuthenticated, setUser) => {
  return (user) => {
    if (!!user) {
      setIsAuthenticated(true);
      setUser(user);
    } else {
      setIsAuthenticated(false);
      setUser(null);
    }
  };
};

const setupFirebase = (setIsAuthenticated, setUser) => {
  firebase.auth().onAuthStateChanged((user) => {
    handleSignIn(setIsAuthenticated, setUser)(user);
  });
};

const logout = (setIsAuthenticated, setUser) => {
  return async () => {
    await firebase.auth().signOut();
    setIsAuthenticated(false);
    setUser(null);
  };
};

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    setupFirebase(setIsAuthenticated, setUser);
  }, []);

  return (
    <AppRouter
      isAuthenticated={isAuthenticated}
      user={user}
      logout={logout(setIsAuthenticated, setUser)}
      handleSignIn={handleSignIn(setIsAuthenticated, setUser)}
    />
  );
}

export default App;
